import { render } from "./ListCustomer.vue?vue&type=template&id=14b70682"
import script from "./ListCustomer.vue?vue&type=script&lang=ts"
export * from "./ListCustomer.vue?vue&type=script&lang=ts"
script.render = render

export default script